import { get, isNil } from 'lodash';
import clearObjectDeep from 'utils/clearObjectDeep';
import omitDeepBy from 'utils/omitDeepBy';
import {
  STYLING_KEY_BODY,
  STYLING_KEY_BUTTON,
  STYLING_KEY_BLOCK,
  STYLING_KEY_LABEL,
  STYLING_KEY_OPTION_TEXT,
  STYLING_KEY_PAGE,
  STYLING_KEY_QUESTION_TEXT,
  STYLING_KEY_STATIC_TEXT,
  STYLING_KEY_TEXTFIELD,
} from 'sharedParts/constants/stylingKey';
import {
  BACKGROUND_COLOR_KEY,
  BACKGROUND_IMAGE_KEY,
  BACKGROUND_POSITION_KEY,
  BORDER_COLOR_KEY,
  BORDER_RADIUS_KEY,
  BORDER_STYLE_KEY,
  BORDER_WIDTH_KEY,
  FONT_COLOR_KEY,
  FONT_FAMILY_KEY,
  FONT_SIZE_KEY,
  FONT_STYLE_KEY,
  FONT_WEIGHT_KEY,
  SELECTION_COLOR_KEY,
  STICK_TO_KEY,
  TEXT_DECORATION_KEY,
  TEXT_TRANSFORM_KEY,
  MARGIN_KEY,
} from 'styling/const/StylingSettingKeys';

export const mapLocalStylingToApiModel = styling =>
  omitDeepBy(
    {
      block_margin: get(styling, [STYLING_KEY_BLOCK, MARGIN_KEY]),
      body_background_color: get(styling, [
        STYLING_KEY_BODY,
        BACKGROUND_COLOR_KEY,
      ]),
      body_background_image: get(styling, [
        STYLING_KEY_BODY,
        BACKGROUND_IMAGE_KEY,
      ]),
      body_background_position: get(styling, [
        STYLING_KEY_BODY,
        BACKGROUND_POSITION_KEY,
      ]),
      button_background_color: get(
        styling,
        `${STYLING_KEY_BUTTON}.${BACKGROUND_COLOR_KEY}`,
      ),
      button_border_color: get(
        styling,
        `${STYLING_KEY_BUTTON}.${BORDER_COLOR_KEY}`,
      ),
      button_border_radius: get(
        styling,
        `${STYLING_KEY_BUTTON}.${BORDER_RADIUS_KEY}`,
      ),
      button_border_style: get(
        styling,
        `${STYLING_KEY_BUTTON}.${BORDER_STYLE_KEY}`,
      ),
      button_border_width: get(
        styling,
        `${STYLING_KEY_BUTTON}.${BORDER_WIDTH_KEY}`,
      ),
      button_font_color: get(
        styling,
        `${STYLING_KEY_BUTTON}.${FONT_COLOR_KEY}`,
      ),
      button_font_size: get(styling, `${STYLING_KEY_BUTTON}.${FONT_SIZE_KEY}`),
      button_font_style: get(
        styling,
        `${STYLING_KEY_BUTTON}.${FONT_STYLE_KEY}`,
      ),
      button_font_weight: get(
        styling,
        `${STYLING_KEY_BUTTON}.${FONT_WEIGHT_KEY}`,
      ),
      button_text_decoration: get(
        styling,
        `${STYLING_KEY_BUTTON}.${TEXT_DECORATION_KEY}`,
      ),
      button_text_transform: get(
        styling,
        `${STYLING_KEY_BUTTON}.${TEXT_TRANSFORM_KEY}`,
      ),
      label_font_color: get(styling, [STYLING_KEY_LABEL, FONT_COLOR_KEY]),
      label_font_size: get(styling, [STYLING_KEY_LABEL, FONT_SIZE_KEY]),
      label_font_style: get(styling, [STYLING_KEY_LABEL, FONT_STYLE_KEY]),
      label_font_weight: get(styling, [STYLING_KEY_LABEL, FONT_WEIGHT_KEY]),
      label_stick_to: get(styling, [STYLING_KEY_LABEL, STICK_TO_KEY]),
      label_text_decoration: get(styling, [
        STYLING_KEY_LABEL,
        TEXT_DECORATION_KEY,
      ]),
      label_text_transform: get(styling, [
        STYLING_KEY_LABEL,
        TEXT_TRANSFORM_KEY,
      ]),
      option_text_decoration: get(
        styling,
        `${STYLING_KEY_OPTION_TEXT}.${TEXT_DECORATION_KEY}`,
      ),
      option_text_font_color: get(
        styling,
        `${STYLING_KEY_OPTION_TEXT}.${FONT_COLOR_KEY}`,
      ),
      option_text_font_family: get(
        styling,
        `${STYLING_KEY_OPTION_TEXT}.${FONT_FAMILY_KEY}`,
      ),
      option_text_font_size: get(
        styling,
        `${STYLING_KEY_OPTION_TEXT}.${FONT_SIZE_KEY}`,
      ),
      option_text_font_style: get(
        styling,
        `${STYLING_KEY_OPTION_TEXT}.${FONT_STYLE_KEY}`,
      ),
      option_text_font_weight: get(
        styling,
        `${STYLING_KEY_OPTION_TEXT}.${FONT_WEIGHT_KEY}`,
      ),
      option_text_transform: get(
        styling,
        `${STYLING_KEY_OPTION_TEXT}.${TEXT_TRANSFORM_KEY}`,
      ),
      page_background_color: get(styling, [
        STYLING_KEY_PAGE,
        BACKGROUND_COLOR_KEY,
      ]),
      question_text_decoration: get(
        styling,
        `${STYLING_KEY_QUESTION_TEXT}.${TEXT_DECORATION_KEY}`,
      ),
      question_text_font_color: get(
        styling,
        `${STYLING_KEY_QUESTION_TEXT}.${FONT_COLOR_KEY}`,
      ),
      question_text_font_family: get(
        styling,
        `${STYLING_KEY_QUESTION_TEXT}.${FONT_FAMILY_KEY}`,
      ),
      question_text_font_size: get(
        styling,
        `${STYLING_KEY_QUESTION_TEXT}.${FONT_SIZE_KEY}`,
      ),
      question_text_font_style: get(
        styling,
        `${STYLING_KEY_QUESTION_TEXT}.${FONT_STYLE_KEY}`,
      ),
      question_text_font_weight: get(
        styling,
        `${STYLING_KEY_QUESTION_TEXT}.${FONT_WEIGHT_KEY}`,
      ),
      question_text_transform: get(
        styling,
        `${STYLING_KEY_QUESTION_TEXT}.${TEXT_TRANSFORM_KEY}`,
      ),
      selection_color: get(styling, SELECTION_COLOR_KEY),
      static_text_decoration: get(
        styling,
        `${STYLING_KEY_STATIC_TEXT}.${TEXT_DECORATION_KEY}`,
      ),
      static_text_font_color: get(
        styling,
        `${STYLING_KEY_STATIC_TEXT}.${FONT_COLOR_KEY}`,
      ),
      static_text_font_family: get(
        styling,
        `${STYLING_KEY_STATIC_TEXT}.${FONT_FAMILY_KEY}`,
      ),
      static_text_font_size: get(
        styling,
        `${STYLING_KEY_STATIC_TEXT}.${FONT_SIZE_KEY}`,
      ),
      static_text_font_style: get(
        styling,
        `${STYLING_KEY_STATIC_TEXT}.${FONT_STYLE_KEY}`,
      ),
      static_text_font_weight: get(
        styling,
        `${STYLING_KEY_STATIC_TEXT}.${FONT_WEIGHT_KEY}`,
      ),
      static_text_transform: get(
        styling,
        `${STYLING_KEY_STATIC_TEXT}.${TEXT_TRANSFORM_KEY}`,
      ),
      textfield_background_color: get(styling, [
        STYLING_KEY_TEXTFIELD,
        BACKGROUND_COLOR_KEY,
      ]),
      textfield_border_color: get(styling, [
        STYLING_KEY_TEXTFIELD,
        BORDER_COLOR_KEY,
      ]),
      textfield_border_radius: get(styling, [
        STYLING_KEY_TEXTFIELD,
        BORDER_RADIUS_KEY,
      ]),
      textfield_border_style: get(styling, [
        STYLING_KEY_TEXTFIELD,
        BORDER_STYLE_KEY,
      ]),
      textfield_border_width: get(styling, [
        STYLING_KEY_TEXTFIELD,
        BORDER_WIDTH_KEY,
      ]),
      textfield_font_color: get(styling, [
        STYLING_KEY_TEXTFIELD,
        FONT_COLOR_KEY,
      ]),
      textfield_font_size: get(styling, [STYLING_KEY_TEXTFIELD, FONT_SIZE_KEY]),
      textfield_font_style: get(styling, [
        STYLING_KEY_TEXTFIELD,
        FONT_STYLE_KEY,
      ]),
      textfield_font_weight: get(styling, [
        STYLING_KEY_TEXTFIELD,
        FONT_WEIGHT_KEY,
      ]),
      textfield_text_decoration: get(styling, [
        STYLING_KEY_TEXTFIELD,
        TEXT_DECORATION_KEY,
      ]),
      textfield_text_transform: get(styling, [
        STYLING_KEY_TEXTFIELD,
        TEXT_TRANSFORM_KEY,
      ]),
    },
    isNil,
  );

export const mapSurveyStylingFromApiModel = data => {
  const styling = data || {}; //  management of `null` as argument's value for old surveys @sinslav
  const {
    block_margin,
    body_background_color,
    body_background_image,
    body_background_position,
    button_background_color,
    button_border_color,
    button_border_radius,
    button_border_style,
    button_border_width,
    button_font_color,
    button_font_size,
    button_font_style,
    button_font_weight,
    button_text_decoration,
    button_text_transform,
    label_font_color,
    label_font_size,
    label_font_style,
    label_font_weight,
    label_stick_to,
    label_text_decoration,
    label_text_transform,
    option_text_decoration,
    option_text_font_color,
    option_text_font_family,
    option_text_font_size,
    option_text_font_style,
    option_text_font_weight,
    option_text_transform,
    page_background_color,
    question_text_decoration,
    question_text_font_color,
    question_text_font_family,
    question_text_font_size,
    question_text_font_style,
    question_text_font_weight,
    question_text_transform,
    selection_color,
    static_text_decoration,
    static_text_font_color,
    static_text_font_family,
    static_text_font_size,
    static_text_font_style,
    static_text_font_weight,
    static_text_transform,
    textfield_background_color,
    textfield_border_color,
    textfield_border_radius,
    textfield_border_style,
    textfield_border_width,
    textfield_font_color,
    textfield_font_size,
    textfield_font_style,
    textfield_font_weight,
    textfield_text_decoration,
    textfield_text_transform,
  } = styling;

  return clearObjectDeep({
    [STYLING_KEY_BODY]: {
      [BACKGROUND_COLOR_KEY]: body_background_color,
      [BACKGROUND_IMAGE_KEY]: body_background_image,
      [BACKGROUND_POSITION_KEY]: body_background_position,
    },
    [STYLING_KEY_BLOCK]: {
      [MARGIN_KEY]: block_margin,
    },
    [STYLING_KEY_BUTTON]: {
      [BACKGROUND_COLOR_KEY]: button_background_color,
      [BORDER_COLOR_KEY]: button_border_color,
      [BORDER_RADIUS_KEY]: button_border_radius,
      [BORDER_STYLE_KEY]: button_border_style,
      [BORDER_WIDTH_KEY]: button_border_width,
      [FONT_COLOR_KEY]: button_font_color,
      [FONT_SIZE_KEY]: button_font_size,
      [FONT_STYLE_KEY]: button_font_style,
      [FONT_WEIGHT_KEY]: button_font_weight,
      [TEXT_DECORATION_KEY]: button_text_decoration,
      [TEXT_TRANSFORM_KEY]: button_text_transform,
    },
    [STYLING_KEY_LABEL]: {
      [FONT_COLOR_KEY]: label_font_color,
      [FONT_SIZE_KEY]: label_font_size,
      [FONT_STYLE_KEY]: label_font_style,
      [FONT_WEIGHT_KEY]: label_font_weight,
      [STICK_TO_KEY]: label_stick_to,
      [TEXT_DECORATION_KEY]: label_text_decoration,
      [TEXT_TRANSFORM_KEY]: label_text_transform,
    },
    [STYLING_KEY_OPTION_TEXT]: {
      [FONT_COLOR_KEY]: option_text_font_color,
      [FONT_FAMILY_KEY]: option_text_font_family,
      [FONT_SIZE_KEY]: option_text_font_size,
      [FONT_STYLE_KEY]: option_text_font_style,
      [FONT_WEIGHT_KEY]: option_text_font_weight,
      [TEXT_DECORATION_KEY]: option_text_decoration,
      [TEXT_TRANSFORM_KEY]: option_text_transform,
    },
    [STYLING_KEY_PAGE]: { [BACKGROUND_COLOR_KEY]: page_background_color },
    [STYLING_KEY_QUESTION_TEXT]: {
      [FONT_COLOR_KEY]: question_text_font_color,
      [FONT_FAMILY_KEY]: question_text_font_family,
      [FONT_SIZE_KEY]: question_text_font_size,
      [FONT_STYLE_KEY]: question_text_font_style,
      [FONT_WEIGHT_KEY]: question_text_font_weight,
      [TEXT_DECORATION_KEY]: question_text_decoration,
      [TEXT_TRANSFORM_KEY]: question_text_transform,
    },
    [SELECTION_COLOR_KEY]: selection_color,
    [STYLING_KEY_STATIC_TEXT]: {
      [FONT_COLOR_KEY]: static_text_font_color,
      [FONT_FAMILY_KEY]: static_text_font_family,
      [FONT_SIZE_KEY]: static_text_font_size,
      [FONT_STYLE_KEY]: static_text_font_style,
      [FONT_WEIGHT_KEY]: static_text_font_weight,
      [TEXT_DECORATION_KEY]: static_text_decoration,
      [TEXT_TRANSFORM_KEY]: static_text_transform,
    },
    [STYLING_KEY_TEXTFIELD]: {
      [BACKGROUND_COLOR_KEY]: textfield_background_color,
      [BORDER_COLOR_KEY]: textfield_border_color,
      [BORDER_RADIUS_KEY]: textfield_border_radius,
      [BORDER_STYLE_KEY]: textfield_border_style,
      [BORDER_WIDTH_KEY]: textfield_border_width,
      [FONT_COLOR_KEY]: textfield_font_color,
      [FONT_SIZE_KEY]: textfield_font_size,
      [FONT_STYLE_KEY]: textfield_font_style,
      [FONT_WEIGHT_KEY]: textfield_font_weight,
      [TEXT_DECORATION_KEY]: textfield_text_decoration,
      [TEXT_TRANSFORM_KEY]: textfield_text_transform,
    },
  });
};
